<template>
  <div id="content" v-if="isLangGeo">
    <div v-if="authenticated" class="gifts">
      <div id="alert-placeholder" class="extra-padding"></div>
      <ul class="thumbnails list-unstyled">
        <li class="col-md-4" v-for="gift in gifts" :key="gift.name">
          <div class="thumbnail padding-0">
            <div :class="{fade: !gift.unblockable}">
              <div class="gift-img-container">
                <img alt="Gift image" class="gift-img" :src="gift.img">
              </div>
              <div class="caption">
                <h2> {{ productName(gift) }} </h2>
                <p> <span class="glyphicon glyphicon-link"></span>
                  <a :href="gift.url" target="_blank"> {{ gift.url }} </a>
                </p>
              </div>
              <div class="modal-footer" style="text-align: left">
                <div class="progress">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    :aria-valuenow="gift.percent"
                    :aria-valuemin="gift.percent"
                    aria-valuemax="100"
                    :style="'width:'+gift.percent+'%;'"
                    style=" min-width: 2em;"
                  >
                    {{ gift.percent }}%
                  </div>
                </div>
                <div class="gift-button-container">
                  <div>
                    <button
                      class="btn btn-primary"
                      role="button"
                      :disabled="!gift.unblockable"
                      @click="setReserve(gift)"
                    >
                      <span v-if="gift.percent < 100">
                        {{ $t("gifts.fund") }}
                      </span>
                      <span v-if="gift.percent == 100 && gift.unblockable">
                        {{ $t("gifts.unfund") }}
                      </span>
                      <span v-if="gift.percent == 100 && !gift.unblockable">
                        {{ $t("gifts.funded") }}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-else>
      <div class="col-md-10 col-md-offset-1">
        <div class="alert alert-success" role="alert">
          <h2> {{ $t("gifts.authenticate") }} </h2>
          <div class="text-center">
            <span class="login-button" :class="textFont">
              <a
                href="#"
                role="button"
                class="btn btn-primary"
                @click="auth.login()"
              >
                {{ $t("app.login") }}
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
const BASE_URL = 'https://shesaidyesto.me'

export default {
  name: 'Gifts',
  props: ['auth', 'authenticated'],
  created: function () {
    var self = this
    if (self.authenticated) {
      self.getGuest().then(function () {
        self.getGifts()
      })
    }
  },
  methods: {
    getGuest: function () {
      const url = `${BASE_URL}/api/guest?token=${localStorage.getItem('id_token')}`
      return axios.get(url, {headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        'Access-Control-Allow-Origin': '*'
      }})
        .then(response => {
          this.guest = response.data
          return Promise.resolve()
        })
        .catch(err => {
          console.log(err)
          this.auth.logout()
        })
    },
    getGifts: function () {
      var self = this
      const url = `${BASE_URL}/api/gifts?token=${localStorage.getItem('id_token')}`
      return axios.get(url, {headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        'Access-Control-Allow-Origin': '*'
      }})
        .then(response => {
          self.$set(self, 'gifts', response.data.gifts)
        })
        .catch(err => {
          this.auth.logout()
        })
    },
    setReserve: function (gift) {
      this.$set(gift, 'percent', gift.percent ? 0 : 100)
      const url = `${BASE_URL}/api/gift?token=${localStorage.getItem('id_token')}`
      return axios({
        method: 'POST',
        url: url,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Access-Control-Allow-Origin': '*'
        },
        data: {
          gift: gift.id,
          percent: gift.percent
        }
      })
        .then(response => this.bootstrapAlert(this.$t('gifts.success'), 'success'))
        .catch(err => this.bootstrapAlert(this.$t('gifts.fail')))
    },
    productName: function (product) {
      return this.$i18n.locale === 'fr' ? product.name_fr : product.name
    },
    bootstrapAlert: function (message, status) {
      status = status || 'warning'
      $(`
        <div class="alert alert-${status} alert-dismissable">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true"> &times; </span>
          </button>
          <span>${message}</span>
        </div>`).appendTo('#alert-placeholder')
    }
  },
  data () {
    return {
      guest: {},
      gifts: []
    }
  },
  computed: {
    textFont: function () {
      return {
        'text-ge': this.$i18n.locale === 'ge',
        'text-fr': this.$i18n.locale === 'fr'
      }
    },
    isLangGeo: function () {
      return this.$i18n.locale === 'ge'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.text-ge {
  font-family: 'Rayuela';
}

.text-fr {
  font-family: 'Moon Flower';
}

.login-button .btn {
  font-size: 2em;
  letter-spacing: 0.15em;
}

.gifts {
  font-family: 'Imeri';
}

.fade {
  opacity: 0.3;
}

.padding-0 {
  padding: 0;
}

.gift-img-container {
  padding: 4px;
  text-align: center;
}

.gift-img {
  max-width: 100%;
  max-height: 200px;
}

.gift-button-container {
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/Gifts.vue